import React, { memo } from 'react'
import { RadioGroup as RadioGroupUI, FormControl, FormLabel, FormHelperText } from '@material-ui/core';
import PropTypes from 'prop-types';
import RadioGroupElement from './RadioGroupElement';
import Tr from 'translations/Translations';

import getObjectValue from 'libs/getObjectValue'
import { withStyles } from '@material-ui/styles';

const style = theme => ({
	error: {
		marginTop: 0,
		marginBottom: theme.spacing(2),
	}
})

const items = [{label: Tr("yes"), value: "true"}, {label: Tr("no"), value: "false"}]

function RadioGroupYesNo({
	classes,
	formikProps,
	label,
	id,
	children,
	className,
	required,
	noError,
	onChange = ()=> {},
	disabled
}) {
	const errorValue = getObjectValue(id, formikProps.errors, '')
	const touched = getObjectValue(id, formikProps.touched, false)
	const value = "" + getObjectValue(id, formikProps.values, '')
	const editable = getObjectValue('_editable', formikProps.values, true);

	const isError = !noError && (!!errorValue && touched)

	// const isError = !!formikProps.errors[id] && formikProps.touched[id]
	const helperText = (isError && errorValue) || ' ';

	let _label = label;
	if (required) _label += '*';

	return (
		<FormControl
			error={isError}
			className={className}
		>
			<FormLabel>{_label}</FormLabel>
			<RadioGroupUI
				name={id}
				onChange={(event) => {
					onChange(event);
					formikProps.handleChange(event);
				}}
				onBlur={formikProps.handleBlur}
				// value={formikProps.values[id]}
				value={value}
			>
				{items.map((item, i) => {
					return (
						<RadioGroupElement
							key={i}
							value={""+item.value}
							disabled={!editable || disabled}
						>
							{item.label}
						</RadioGroupElement>
					)
				})}
				{children}
			</RadioGroupUI>
			<FormHelperText className={classes.error}>{helperText}</FormHelperText>
		</FormControl>
	)
}

RadioGroupYesNo.propTypes = {
	classes: PropTypes.any,
	label: PropTypes.string,
	id: PropTypes.string,
	formikProps: PropTypes.object,
}

RadioGroupYesNo.defaultProps = {
	items: []
}

export default withStyles(style)(memo(RadioGroupYesNo, (prevProps, nextProps) => {
	if (prevProps.label !== nextProps.label) return false;
	if (prevProps.id !== nextProps.id) return false;
	if (prevProps.disabled !== nextProps.disabled) return false;
	if (JSON.stringify(prevProps.items) !== JSON.stringify(nextProps.items)) return false;
	if (prevProps.children !== nextProps.children) return false;
	const id = nextProps.id;
	// if (prevProps.formikProps.values[id] !== nextProps.formikProps.values[id]) return false;
	// if (prevProps.formikProps.errors[id] !== nextProps.formikProps.errors[id]) return false;
	// if (prevProps.formikProps.touched[id] !== nextProps.formikProps.touched[id]) return false;
	if (getObjectValue(id, prevProps.formikProps.values) !== getObjectValue(id, nextProps.formikProps.values)) return false;
	if (getObjectValue(id, prevProps.formikProps.errors) !== getObjectValue(id, nextProps.formikProps.errors)) return false;
	if (getObjectValue(id, prevProps.formikProps.touched) !== getObjectValue(id, nextProps.formikProps.touched)) return false;
	return true;
}))